import script from "./stock-report.vue?vue&type=script&lang=ts&setup=true"
export * from "./stock-report.vue?vue&type=script&lang=ts&setup=true"

import "./stock-report.vue?vue&type=style&index=0&id=f159ae86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f159ae86"]])

export default __exports__